<template>
    <v-card class="mx-auto" max-width="400" :class="{ 'show-card': show }">
        <v-card-title @click="show = !show">
            {{ data.title }}
        </v-card-title>
        <v-card-subtitle v-if="data.date_expires && status == 'Available'">
            <strong>Expiry date:</strong> {{ data.date_expires }}        
        </v-card-subtitle> 
        <v-card-subtitle v-else-if="status == 'Applied'">
            <strong>Applied date:</strong> {{ data.date_applied }}        
        </v-card-subtitle> 
        <v-card-subtitle>
            <strong>{{ data.subtitle }}</strong>
        </v-card-subtitle>
         <v-btn @click="show = !show" :class="{ 'open': show }"></v-btn>
        <v-expand-transition>
            <div v-show="show" class="slider-card-block">
                <v-divider></v-divider>
                <v-card-text class="row-table">
                    <div>
                        <span><strong>Code:</strong></span>
                        <span>{{ data.code }}</span>
                    </div>
                    <div>
                        <span><strong>Status:</strong></span>
                        <span> {{ status }}</span>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>                   
                    <h4>How to apply this reward</h4>
                    {{ data.description }}
                </v-card-text>
                <div class="row-btn" v-if="status == 'Available'">
                    <button 
                        class="btn btn-apply" 
                        @click="ApplyDiscount"
                        :class="{'disabled': disabled }"
                    >
                        {{ btnTitle }}
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M6.07415 13.234C6.28115 13.428 6.45815 13.694 6.70415 13.797C6.98515 13.915 7.32915 13.877 7.61515 13.867C7.84915 13.858 8.21415 13.854 8.50215 13.855C10.8101 13.856 13.1181 13.858 15.4261 13.859C15.9541 13.859 16.4831 13.859 17.0061 13.793C17.1981 13.769 17.3941 13.735 17.5831 13.776C18.3141 13.932 18.0001 14.91 17.5591 15.232C17.2611 15.45 16.7981 15.406 16.4521 15.383C15.9611 15.351 15.4721 15.341 14.9771 15.337C13.8481 15.327 12.7201 15.318 11.5911 15.308C11.0091 15.303 10.4581 15.385 9.88515 15.43C9.22415 15.482 8.53515 15.427 7.87215 15.426C7.15315 15.426 6.52015 15.431 5.88415 15.039C5.47715 14.788 5.06115 14.478 4.79415 14.093C4.42015 13.552 4.28115 12.696 4.11815 12.065C3.91115 11.262 3.75915 10.446 3.66515 9.62203C3.60215 9.07703 3.56415 8.52903 3.48815 7.98503C3.40615 7.40303 3.27915 6.82803 3.15215 6.25303C3.02915 5.69403 2.90515 5.13603 2.78215 4.57703C2.73815 4.37703 2.69315 4.17503 2.61015 3.98703C2.21415 3.09303 1.10615 2.70303 0.411146 2.08503C0.252146 1.94703 0.0621457 1.78703 0.0121457 1.60203C-0.0318543 1.44303 0.0551457 1.11803 0.165146 1.07503C0.950146 0.770029 2.08015 1.47003 2.73515 1.83003C2.78215 1.85603 2.97115 2.03303 3.00515 2.03103C3.19915 2.02203 3.72515 2.85503 3.86715 3.09603C3.92115 3.18703 4.18415 3.86503 4.17115 3.92203C4.37815 3.94103 11.2361 3.89103 14.3721 3.89203C15.9191 3.89203 17.6991 3.71103 19.1781 4.23003C19.4891 4.33903 19.9351 4.62203 19.9641 4.87003C20.1091 6.09403 19.7831 7.29903 19.5461 8.48903C19.3101 9.67703 19.4171 10.704 18.3191 11.459C18.0211 11.664 17.7281 11.985 17.3821 12.107C16.9991 12.242 16.4731 12.232 16.0661 12.287C15.1111 12.415 14.1531 12.523 13.1931 12.611C12.0541 12.715 10.9121 12.79 9.76915 12.836C9.19715 12.859 8.62615 12.875 8.05415 12.883C7.83115 12.886 7.59815 12.937 7.39015 12.945C7.20215 12.952 7.04815 12.88 6.86215 12.876C6.62015 12.871 6.37715 12.896 6.13615 12.923C6.09215 12.928 6.03415 13 6.02515 13.049C6.02015 13.079 6.09715 13.123 6.13715 13.161C6.11615 13.185 6.09515 13.209 6.07515 13.233L6.07415 13.234ZM7.48815 5.38703C7.10215 5.38303 4.60115 5.38203 4.58515 5.26903C4.73015 6.13503 4.89515 7.11603 5.04715 8.02003C5.20515 9.15403 5.35215 10.21 5.51415 11.375C7.34815 11.375 13.0321 11.115 13.9891 11.046C14.5761 11.004 15.1641 10.972 15.7471 10.897C16.1091 10.851 16.4591 10.723 16.8191 10.651C17.5001 10.514 17.7701 10.192 17.7341 9.53803C17.7301 9.46503 17.7361 9.38803 17.7581 9.31803C17.8771 8.93503 18.0331 8.56003 18.1171 8.17003C18.2641 7.48803 18.3351 6.78903 18.5061 6.11403C18.5781 5.83003 18.6201 5.77303 18.3781 5.61003C18.0441 5.38403 17.5061 5.40703 17.1241 5.41303C14.9991 5.44403 12.8741 5.45003 10.7501 5.43203C9.67515 5.42303 8.59915 5.40803 7.52415 5.38703C7.51615 5.38703 7.50415 5.38703 7.48915 5.38703H7.48815ZM15.9451 16.123C16.3501 16.485 16.4471 17.055 16.2641 17.588C16.1551 17.905 15.9291 18.181 15.7171 18.451C15.5631 19.052 13.3401 19.242 12.8981 18.635C12.6041 18.231 12.1081 17.876 12.3391 17.25C12.4571 16.931 12.5111 16.554 12.7221 16.314C12.9441 16.061 13.3011 15.899 13.6281 15.776C13.9311 15.662 15.5931 15.809 15.9461 16.124L15.9451 16.123ZM15.1301 17.192C15.1111 17.098 15.0931 17.003 15.0741 16.909C14.7961 16.846 14.4941 16.685 14.2471 16.747C13.9881 16.812 13.5911 17.089 13.5901 17.276C13.5871 17.824 14.1151 17.749 14.4411 17.692C14.6921 17.649 14.9011 17.368 15.1291 17.193L15.1301 17.192ZM7.52415 18.777C6.81315 18.072 6.54715 17.283 7.12315 16.337C7.75915 15.293 8.56215 15.421 9.46615 15.966C10.2381 16.526 10.4361 17.208 9.95615 18.144C9.45615 19.117 8.64315 19.009 7.75415 18.904C7.72315 18.887 7.62315 18.832 7.52415 18.777ZM9.16015 17.184C9.11915 16.999 8.44415 16.7 8.29515 16.604C8.26815 16.587 8.23815 16.569 8.20715 16.575C8.18115 16.58 8.16015 16.6 8.14215 16.62C8.04315 16.725 7.94315 16.836 7.89515 16.972C7.82615 17.168 7.87915 17.397 8.01115 17.558C8.14315 17.719 8.34515 17.814 8.55215 17.837C8.64915 17.848 8.75415 17.841 8.83315 17.785C8.89215 17.742 8.93015 17.677 8.96615 17.613C9.01215 17.531 9.05915 17.449 9.10515 17.367C9.13515 17.314 9.16615 17.257 9.16115 17.196C9.16115 17.192 9.16115 17.189 9.15915 17.185L9.16015 17.184ZM7.29115 7.25903C6.60915 7.31103 6.55715 7.70303 7.22815 7.77403C7.23715 7.77403 7.24415 7.77603 7.24915 7.77603C8.79615 7.85803 13.8481 7.95003 14.8261 7.94003C15.2081 7.93603 15.5081 7.87303 15.5291 7.54503C15.5461 7.28303 15.1961 7.05203 14.7821 7.05603C14.5021 7.05903 7.95015 7.20903 7.29115 7.25903ZM7.29115 9.22603C6.60915 9.27803 6.55715 9.67003 7.22815 9.74103C7.23715 9.74103 7.24415 9.74303 7.24915 9.74303C8.79615 9.82503 13.8481 9.91703 14.8261 9.90703C15.2081 9.90303 15.5081 9.84003 15.5291 9.51203C15.5461 9.25003 15.1961 9.01903 14.7821 9.02303C14.5021 9.02603 7.95015 9.17603 7.29115 9.22603Z" fill="white"/>
                        </svg>
                    </button>               
                </div>
                <div class="row-alert" v-if="status == 'Available' && disabled == true ">
                    <p>The reward will be taken into account when the next payment is debited.</p>
                </div>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>

import Cookies from 'js-cookie';

export default {
    name: 'cardInfo',
    props: ['data', 'status'],
    data: () => ({
        show: false,
        disabled: false,
    }),
    computed: {
        btnTitle() {
            if (  this.disabled ) {
                return 'Discount selected';
            } else {
                return 'Apply discount';
            }
        }
    },
    methods: {
        ApplyDiscount() {

            if ( Cookies.get('coupon') ) {
                if ( this.disabled ) {                   
                    this.disabled = false;
                    Cookies.remove('coupon');
                }
            } else {
                this.disabled = true;
                Cookies.set('coupon', this.data.code, { expires: 3600 });
            }  
            
        }
    },
    async beforeMount() {
        if (Cookies.get('coupon') && Cookies.get('coupon') == this.data.code ) {
            this.disabled = true;
        }
    }
}
</script>

<style lang="stylus">

ul {
    list-style: none;
    margin: 0;
    padding: none;
}

.slider-card-block {
    margin-top: 20px;
}

.available-items {
    ul {
        display: flex;
        flex-wrap: wrap;
        gap: 2rem;
        margin-top: 2rem;

        li {
            width: calc(33% - 1.2rem);

            & > .v-card {
                position: relative;
                padding-left: 60px;

                &:after {
                   position: absolute;
                   content: ''
                   left: 20px;
                   top: 16px;
                   width: 31px;
                   height: 31px;
                   fill: #201747;
                   background-size: cover;
                }

                & > button {
                    position: absolute;
                    top: 0;
                    right: 0;
                    background: url(/src/assets/images/icons/Arrow-Down.svg) no-repeat center / 20px 20px;
                }

                &.show {
                    &:after {
                        fill: #685BC7;
                    }
                }
                
            }
        }
    }
}

.v-card {
    .v-card-title {        
        font-weight: 800;
        line-height: 30px;
        font-size: 18px;        
    }

    .v-card-subtitle {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 14px;
        font-weight: 700;
        line-height: 19.12px;
        text-align: left;
        opacity: 1!important;
        
    }

    &.show-card {

        & > button,
        &:after {
            filter: saturate(1800%) brightness(70%);
        }

        .v-card-subtitle,
        .v-card-title {
            color: #685BC7;
        }

        .row-btn button svg {
            transition: all 0.3s ease-out 0s;
        }
        .row-btn button:hover svg {
            filter: brightness(.1);
        }
    }

    .v-divider.v-theme--light {
        margin: 0;
    }

    .v-card-text {
        font-famaly: 'Manrope', sans-sarif;
        font-size: 16px;

        h4 {
            color: #685BC7;
            font-family: 'Manrope', sans-serif;
            font-size: 16px;
            font-weight: 800;
            line-height: 21.86px;
            text-align: left;
            margin-bottom: 7px
        }
    }

    .btn.btn-apply {
        text-align: center;
        width: 100%;
        background-color: #685BC7;
        border-radius: 16px;
        color: #fff;
        transition: all 0.3s ease-out 0s;
        font-size: 16px;
        height: 50px;

        &:hover {
            background: #2ad2c9;
            color: #1d2433;
        }
        
        &.disabled {
            opacity: .5; 
            
            &:hover {
                background: #685BC7;
                color: #fff;

                svg {
                    filter: none;
                }
            }
        }
    }

    .row-table {
        display: grid;
        gap: 20px;
        grid-template-columns: 1fr 1fr;

        & > div {
            display: flex;
            flex-direction: column;

            span {
                font-family: 'Manrope', sans-serif;
                font-size: 14px;
                font-weight: 400;
                line-height: 19.12px;
                text-align: left;

                & > strong {
                    color: #685BC7;
                }
            }

            &:first-child {
                span + span {
                    text-transform: uppercase;
                }
            }
            
            &:last-child {
                span + span {
                    text-transform: capitalize;
                }
            }
        }
    }
}

ul li.type-friend {
    .v-card:after {
        width: 41px!important;
        height: 41px!important;
        background-size: contain!important;
        background: url(/src/assets/images/icons/freind.svg) no-repeat center / 41px 41px;
    }
}

.type-birthday {
    .v-card:after {
        background: url(/src/assets/images/icons/heart.svg) no-repeat center / 31px 31px;
    }
}

.type-shipping {
    .v-card:after {
        background: url(/src/assets/images/icons/basket.svg) no-repeat center / 31px 31px;
    }
}

.type-other {
    .v-card:after {
        background: url(/src/assets/images/icons/cookie.svg) no-repeat center / 31px 31px;
    }
}

</style>